import { MetricCard, MetricGrid } from "@nymbl/nos2-rules";
import { formatPct, type TeamTotals } from "@/lib/team/metrics";

export function TeamTotalsBar({ totals }: { totals: TeamTotals }) {
  return (
    <section aria-label="Team totals">
      <MetricGrid>
        {totals.started && (
          <>
            <MetricCard label="Utilization" value={formatPct(totals.utilization)} />
            <MetricCard label="Billable" value={formatPct(totals.billablePct)} />
          </>
        )}
        <MetricCard label="Guidance" value={formatPct(totals.plannedPct)} />
      </MetricGrid>
    </section>
  );
}
